import { computed, Ref } from "vue"
import { useQuery } from "@tanstack/vue-query"
import http from "@/http-common"
import { TilatunnusDuplicatesResponse } from "@/api/models/tilatunnus-duplicates-response"

export function useTilatunnusDuplicates(hankeId: Ref<number | undefined>) {
    const queryKey = computed(() => ["tilat", "duplicates", hankeId.value])
    const enabled = computed(() => hankeId.value !== undefined)

    const fetcher = async (): Promise<TilatunnusDuplicatesResponse> => {
        const response = await http.get(`tilat/hankeId/${hankeId.value}/duplicates`)
        return response.data
    }

    const {
        data: duplicates,
        error,
        isLoading: loading,
        refetch
    } = useQuery({
        queryKey: queryKey,
        queryFn: fetcher,
        enabled
    })

    const hasDuplicates = computed(() => duplicates.value?.duplicates && duplicates.value.duplicates.length > 0)
    const duplicateCount = computed(() => duplicates.value?.duplicates?.length || 0)

    return {
        duplicates,
        hasDuplicates,
        duplicateCount,
        loading,
        error,
        refetch
    }
}